import { useQuery } from '@tanstack/react-query';
import { Link, Outlet, useParams } from 'react-router';
import { getApplicationFormInfo } from '@/api/Rover/ApplicationForm';

export function ApplicationFormLayout() {
  const { applicationFormId } = useParams<string>();

  //Tanstack: version 5 query implementation
  const fetchApplicationForm = useQuery({
    queryKey: ['GET_APPLICATION_FORM_INFO'],
    queryFn: () => getApplicationFormInfo({ applicationFormId: applicationFormId! }),
  });
  const applicationFormLogo = fetchApplicationForm?.data?.data?.logo;

  return (
    <div className='h-screen flex flex-col justify-between gap-2'>
      <header className='text-gray-600 body-font bg-white w-full'>
        <div className='container w-full mx-auto flex flex-col md:flex-row md:items-center md:justify-between p-5'>
          <div className='w-1/2 md:w-1/4 lg:w-48 mx-auto md:mx-0'>
            <Link to='/'>
              <img src={applicationFormLogo} alt='Application Form Logo' />
            </Link>
          </div>
        </div>
      </header>
      <Outlet />
      <footer className='flex gap-2 bg-white py-6 px-5 text-sm justify-between items-center'>
        <div className='flex flex-col gap-2'>
          <p className='text-neutralColor-normal flex gap-4 text-xs md:text-sm'>
            <a href='https://sein.tech/about' target='_blank' rel='noreferrer' className='hover:text-secondaryColor-normal cursor-pointer'>
              About
            </a>
            <a
              href='https://sein.tech/terms-of-use'
              target='_blank'
              rel='noreferrer'
              className='hover:text-secondaryColor-normal cursor-pointer'
            >
              Terms of use
            </a>
            <a
              href='https://sein.tech/privacy-policy'
              target='_blank'
              rel='noreferrer'
              className='hover:text-secondaryColor-normal cursor-pointer'
            >
              Privacy
            </a>
          </p>
        </div>
        <div className='flex-1 flex flex-col items-center gap-2'>
          <div className='flex items-center gap-2'>
            <span className='text-neutralColor-normal text-xs'>Powered By:</span>
            <img
              src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png'
              alt='Sein Terminal Logo'
              className='h-10 w-25'
            />
          </div>
          <p className='text-neutralColor-normal text-xs'>&#169; {new Date().getFullYear()} SEIN Technology Partners Inc</p>
        </div>
      </footer>
    </div>
  );
}
